define.alias("shared/components/shared/carousel/index", "media/components/shared/carousel/index");